export const selectForm = state => state.form;

export const selectFormByName = (state, name) => {
  const form = selectForm(state);
  return form[name];
};
